module.exports = __webpack_public_path__ + "img/icon-1.4c25db37.png";